export const getFromLocalStorage = (key) => {
  const storedValue = window.localStorage.getItem(key);

    try {
        const parsedValue = JSON.parse(storedValue);

        if (Array.isArray(parsedValue) || (typeof parsedValue === 'object' && parsedValue !== null)) {
            return parsedValue;
        }
    } catch (error) {
        // Parsing as JSON failed, return the original stored value
        // console.log(error,"parsing error")
    }

    return storedValue;
}



export const setInLocalStorage = (key, newValue) => {
  if (typeof newValue === 'object') {
    const parsedValue = JSON.stringify(newValue)
    const setValue = window.localStorage.setItem(key, parsedValue)
    return setValue
  }else{
    const setValue = window.localStorage.setItem(key, newValue)
    return setValue
  }
}

export const removeFromLocalStorage = (key) => {
  if (localStorage.getItem(key)) {
    window.localStorage.removeItem(key)
  }
}
export const makeKeyAsNullInLocalStorage = (key) => {
  if (localStorage.getItem(key)) {
    window.localStorage.setItem(key, "")
  }
}
